export default "__VITE_ASSET__A_33BEAv__"